module.exports = "<select class=\"select2-select q-input disabled products-tab-uom\" style=width:100% name=\"prodTabUom_row_{%- highestId %}\" data-minimum-results-for-search=Infinity data-target-closest=.divider-group {%- isDisabled %}> {%= dropDownOptions %} </select> <input type=hidden class=prod-tab-unitsPerCase name=\"prodTabUnitperCase_row_{%- highestId %}\" value=\"{%- unitsPerCase %}\"> <input type=hidden class=prod-tab-unitsPerPallet name=\"prodTabUnitPerPallet_row_{%- highestId %}\" value=\"{%- unitsPerPallet %}\">";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/unitOfMeasure.html
// module id = 1372
// module chunks = 1